// @ts-ignore
import createClickStream from '@uchi/client-clickstream';
import getConfig from 'next/config';
import { getCookie } from 'utils/cookie/getCookie';

const {
  publicRuntimeConfig: { CLICKSTREAM_HOST },
} = getConfig();

interface PageViewProps {
  id: number | undefined | null;
  userType: string | undefined;
  cd1?: string;
  cd2?: string;
  cd3?: string;
}

const clickStreamPageview = ({ id, userType, cd2, cd3 }: PageViewProps) => {
  if (CLICKSTREAM_HOST) {
    const clickstream = createClickStream({
      host: CLICKSTREAM_HOST,
      options: { version: 7 },
    });

    clickstream
      .pageView({
        userType: userType || 'guest',
        userId: id || 0,
        guestUuid: getCookie('GuestUUID'),
        customDimentions: {
          cd1: getCookie('GuestID'),
          cd2,
          cd3,
        },
      })
      // @ts-ignore
      .then((res) => {
        if (res.status === 422) {
          console.error('logger pageviews data is not valid for this schema');
        }
      })
      .catch(() => console.log('Logger pageView error'));
  }
};

export default clickStreamPageview;
